import { gspx } from '@rsos/gainsight';

export const trackAlertShareSubmit = (
  numEmailRecipients,
  numSMSRecipients,
  irpVersion,
) => {
  gspx.trackCustomEvent('Alert', {
    irpVersion,
    name: `User shares alert to first responders`,
    Category: 'Alert',
    'Launched date': new Date(),
    numEmailRecipients: numEmailRecipients,
    numSMSRecipients: numSMSRecipients,
  });
};
